// Runtime detection of the Telegram Mini App environment.
//
// When the mini-app is opened inside the Telegram client,
// `window.Telegram.WebApp` is populated by the Telegram JS SDK loaded
// via the platform's telegram-web-app.js. Outside of Telegram (regular
// browser) the property is absent — the app then falls back to cookie
// / magic-link auth automatically.
//
// `initData` is the query-string-encoded payload Telegram signs with
// our bot token. We forward it verbatim on every request; the backend
// validates HMAC-SHA256 (see apps/api/src/lib/tg-init-data.ts).

interface TelegramWebApp {
  initData: string;
  ready?: () => void;
  expand?: () => void;
  MainButton?: unknown;
  themeParams?: unknown;
}

interface TelegramGlobal {
  WebApp?: TelegramWebApp;
}

// Extend the Window type without collapsing other declarations.
declare global {
  interface Window {
    Telegram?: TelegramGlobal;
  }
}

export function isTelegram(): boolean {
  return typeof window !== "undefined" && !!window.Telegram?.WebApp?.initData;
}

export function tgInitData(): string | null {
  if (!isTelegram()) return null;
  return window.Telegram?.WebApp?.initData ?? null;
}

// Called once at app bootstrap. Signals to Telegram that the mini-app
// is ready to show (removes the loading spinner) and expands to full
// viewport height so the passport doesn't render inside a
// half-collapsed sheet.
export function initTelegramIfPresent(): void {
  const wa = window.Telegram?.WebApp;
  if (!wa) return;
  try {
    wa.ready?.();
    wa.expand?.();
  } catch {
    // The SDK sometimes throws on older TG clients — non-fatal.
  }
}
